import React, { FC, useCallback } from 'react'

import { Loader, ErrorHandler, Header, InterSvgIcon } from 'components'
import { Page, PageContent, makeTraceDetails } from 'common'
import { logBridgeError, sendSelectContent } from 'common/helpers'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'
import { Routes } from 'common/constants'
import { useNavigate } from 'react-router-dom'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { isEmpty } from 'lodash'
import { Button } from 'common/styles/layouts'

import { Text } from '@interco/inter-ui/components/Text'

import { MainContent } from './styles'

export const SuccessEmailSent: FC = () => {
  const { privacyCenterContent, isAppLoading, isAppError, isAppActive, userSelectedEntity } =
    useAppContext()

  const navigate = useNavigate()

  const closeHandler = useCallback(async () => {
    try {
      await sendSelectContent({
        flow: 'success_email_sent',
        step: 'success_email_sent',
        screen_name: Routes.SUCCESS_EMAIL_SENT,
        element_name: 'closeSuccessEmailSent',
        element_type: 'button',
        parent_name: 'SuccessEmailSent',
        scenario: JSON.stringify({
          screen: Routes.SUCCESS_EMAIL_SENT,
          product: userSelectedEntity,
          ref_type: 'button',
          content_action: 'touch',
        }),
      })
    } catch (error: unknown) {
      logBridgeError('send success email sent close tic', error)
    }

    navigate(Routes.REPORTS_HISTORY)
  }, [navigate, userSelectedEntity])

  useScreenFinishLoadTac({
    name: 'SuccessEmailSent',
    entity: userSelectedEntity,
    action: 'SuccessEmailSent',
    screen: Routes.SUCCESS_EMAIL_SENT,
    shouldSend: true,
    logLabel: 'send success email sent tac',
  })

  if (isAppLoading) return <Loader />

  const content = privacyCenterContent?.components?.requestedReportByEmailSuccessFeedback?.content

  const isActive = privacyCenterContent?.components?.requestedReportByEmailSuccessFeedback?.isActive

  const isErrorOrInactive = isAppError || isEmpty(content) || !isActive || !isAppActive

  if (isErrorOrInactive) {
    const traceDetails = makeTraceDetails(!!isActive, content)

    return <ErrorHandler traceDetails={traceDetails} componentName={SuccessEmailSent.name} />
  }

  const { title, details, confirmButton, icon } = content

  return (
    <Page>
      <Header title="" goToPath={Routes.REPORTS_HISTORY} />
      <PageContent>
        <MainContent>
          {icon && <InterSvgIcon iconRef={icon} height={64} width={64} color="var(--orange500)" />}
          <Text variant="headline-h1" color="typography" semiBold>
            {title}
          </Text>
          <Text variant="body-3">{details}</Text>
        </MainContent>
        <Button
          variant="primary"
          color="typography"
          style={{ marginBottom: '1rem' }}
          onClick={closeHandler}
        >
          {confirmButton}
        </Button>
      </PageContent>
    </Page>
  )
}
